import React from "react";

//component

import JobListingBanner from "views/job-listing/components/JobListingBanner";
import FooterSection from "views/home/components/FooterSection";
import AllJobs from "views/job-listing/components/AllJobs";
// import "../css/Index.css";
import Token from "api/Auth/auth";
import store from "store.js";
import { setMgToken, setHcToken } from "store/Auth";
import { connect } from "react-redux";
import { getMoreJobsOnScrollAction } from "store/Home";
import { getAllSearchResultsAction, mainGroupAction } from "store/JobList";

class JobDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
    };
  }
  async componentDidMount() {
    try {
      const payload = {
        From: 1,
        PageNo: 0,
        limit: 5,
      };
      let HcToken = await Token.getToken();
      store.dispatch(setHcToken(HcToken));
      let MgToken = await Token.getTokenMagitt();
      store.dispatch(setMgToken(MgToken));
      let getMoreJobResponse = await this.props.getMoreJobsOnScrollAction(
        payload
      );
      this.setState({ jobs: getMoreJobResponse.Data });
      let res = await this.props.mainGroupAction();
      // this.setState({
      //   maingroup:this.props.maingroup
      // })
    } catch (error) {}
  }
  render() {
    return (
      <div className="mt-80px  lg:pt-8 md:pt-8">
        <div className="mx-auto container mb-4 lg:block md:block hidden">
          <ul className="bradcrumb flex">
            <li className="bradcrumb-li fsize14">Home </li>&nbsp;/&nbsp;
            <li className="text-black fsize14 font-semibold">All Jobs</li>
          </ul>
        </div>

        <div className="mx-auto container ">
          <JobListingBanner jobs={this.state.jobs} />
        </div>

        <div className="mx-auto container">
          <AllJobs jobs={this.state.jobs} />
        </div>

        <div className="mt-6 footer-css">
          <FooterSection jobs={this.state.jobs} />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    getmorejobs: state.Home.home.GETMOREJOBS,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getMoreJobsOnScrollAction: async (payload) =>
      await dispatch(getMoreJobsOnScrollAction(payload)),
    mainGroupAction: async (payload) =>
      await dispatch(mainGroupAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(JobDetails);
